/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description utils for config
 */

import _ from 'lodash';

// Custom encrypt function using a secure key
const encryptText = (text: string): string => {
	const key = SESSION_ENCRYPTION_KEY;
	if (!key) {
		return text;
	}

	const keySum = _.sumBy(key, (k) => k.charCodeAt(0)) % 26; // Keep it within a valid range

	return _.chain(text)
		.split('')
		.map((char) => {
			if (!/[a-zA-Z0-9]/.test(char)) {
				return char; // Keep special characters (like @ and .) unchanged
			}

			const charCode = char.charCodeAt(0);

			// Handle numbers (0-9)
			if (/\d/.test(char)) {
				return String((parseInt(char, 10) + keySum) % 10);
			}

			// Handle letters (A-Z, a-z)
			const isUpperCase = char >= 'A' && char <= 'Z';
			const base = isUpperCase ? 65 : 97;
			const newCharCode = ((charCode - base + keySum) % 26) + base;

			return String.fromCharCode(newCharCode);
		})
		.join('')
		.value();
};

// custom decrypt function
const decryptText = (hashedText: string, key: string): string => {
	const keySum = _.sumBy(key, (k) => k.charCodeAt(0)) % 26; // Keep it within a valid range

	return _.chain(hashedText)
		.split('')
		.map((char) => {
			if (!/[a-zA-Z0-9]/.test(char)) {
				return char; // Keep special characters unchanged
			}

			const charCode = char.charCodeAt(0);

			// Handle numbers (0-9)
			if (/\d/.test(char)) {
				const hashedNum = parseInt(char, 10);
				return String((((hashedNum - keySum) % 10) + 10) % 10);
			}

			// Handle letters (A-Z, a-z)
			const isUpperCase = char >= 'A' && char <= 'Z';
			const base = isUpperCase ? 65 : 97;
			const originalCharCode = ((charCode - base - keySum + 26) % 26) + base; // Ensure non-negative wraparound

			return String.fromCharCode(originalCharCode);
		})
		.join('')
		.value();
};

// mask text custom function
const maskText = (input: string): string => {
	if (!_.some(input, (char) => /[a-zA-Z0-9]/.test(char))) {
		return input;
	}
	return encryptText(input);
};

// posthog's own events to block
const POSTHOG_EVENTS_TO_BLOCK = ['$pageleave', '$dead_click', '$rageclick'];

export { POSTHOG_EVENTS_TO_BLOCK, decryptText, maskText, encryptText };
